import { mapGetters, mapActions } from 'vuex';
import SubstanceService from '../services/SubstanceService';
import DefaultDate from '../filters/DefaultDate';

export default {
    data() {
        return {
            loading: false,
            info: {
                name: '',
                publishDate: window.moment().add(1, 'day').startOf('day').format(),
                deleted: false,
                internalNote: '',
                sendNotification: true,
            },
            productNumbers: [],
            routeOfAdministrations: [],
            selectedSubstances: [],
            selectedGlobalNotes: [],
            localNotes: [],
            globalNotes: [],
        };
    },
    computed: {
        ...mapGetters({
            getAllGlobalNotesFromDatetime: 'globalnotes/getAllGlobalNotesFromDatetime',
            getAllSubstancesFromDatetime: 'substances/getAllSubstancesFromDatetime',
            getSingleSubstance: 'substances/getSingleSubstance',
            getAllRouteOfAdministration: 'routeofadministration/getAllRouteOfAdministration',
        }),
        activeSubstancesList() {
            return this.getAllSubstancesFromDatetime(this.info.publishDate).filter(substance => !substance.deleted);
        },
        mappedSubstances() {
            return this.selectedSubstances.map(substance => substance.id);
        },
        mappedRouteOfAdministrations() {
            return this.routeOfAdministrations.filter(route => route.selected).map(route => route.id);
        },
        mappedGlobalNotes() {
            return this.selectedGlobalNotes.map(id => ({ id }));
        },
        mappedLocalNotes() {
            return this.localNotes.filter(note => !note.inherited && note.iconID > 0);
        },
        requestData() {
            return {
                info: { ...this.info, ...{ publishDate: DefaultDate(this.info.publishDate) } },
                substances: this.mappedSubstances,
                routeOfAdministrations: this.mappedRouteOfAdministrations,
                localNotes: this.mappedLocalNotes,
                globalNotes: this.mappedGlobalNotes,
                productNumbers: this.productNumbers,
            };
        },
        filteredGlobalNotes() {
            return this.globalNotes.map((note) => {
                const inherited = this.selectedSubstances.find((substance) => {
                    if (substance && substance.globalNotes) {
                        return substance.globalNotes.find(subNote => subNote.id === note.id);
                    }
                    return null;
                });

                if (!!inherited === true) {
                    return { ...note, inherited: true, selected: true };
                }

                return { ...note, selected: this.selectedGlobalNotes.includes(note.id) };
            });
        },
        filteredLocalNotes() {
            const substanceNotes = this.selectedSubstances
                .reduce((acc, { localNotes }) => {
                    if (localNotes) {
                        return [...acc, ...localNotes];
                    }
                    return acc;
                }, [])
                .map(item => ({ ...item, inherited: true }));

            return [...this.localNotes, ...substanceNotes];
        },
    },
    methods: {
        ...mapActions({
            loadGlobalNotes: 'globalnotes/loadGlobalNotes',
            loadRouteOfAdministration: 'routeofadministration/loadRouteOfAdministration',
            loadSubstances: 'substances/loadSubstances',
        }),
        initGlobalNotes() {
            this.globalNotes = this.getAllGlobalNotesFromDatetime(this.info.publishDate)
                .map(note => ({ ...note, selected: note.selected || false, inherited: false }))
                .filter(note => note.deleted === false);
        },
        onToggleNote(note) {
            if (note.selected) {
                this.selectedGlobalNotes.push(note.id);
                return;
            }

            this.selectedGlobalNotes = this.selectedGlobalNotes.filter(noteId => noteId !== note.id);
        },
        async onToggleSelectSubstance(payload) {
            this.$nextTick(async () => {
                try {
                    // I am pretty certain item === payload but I am leaving it like that for now
                    const item = this.selectedSubstances.find(sub => sub.id === payload.id);
                    const substance = await SubstanceService.getSingle(item.id, this.info.publishDate);

                    this.selectedSubstances = this.selectedSubstances.map(selectedItem => (selectedItem.id === item.id ? { ...selectedItem, ...substance } : selectedItem));
                } catch (error) {
                    // If substance does not exists on the current publishDate then remove it from the list
                    this.selectedSubstances = this.selectedSubstances.filter(substance => substance.id !== payload.id);
                }
            });
        },
        refreshSelectedSubstances() {
            this.selectedSubstances.forEach(item => this.onToggleSelectSubstance(item));

            this.selectedGlobalNotes = this.selectedGlobalNotes
                .filter(note => this.globalNotes.some(curNote => curNote.id === note));
        },
        onRemoveLocalNote(localIndex) {
            this.localNotes = this.localNotes.filter((_, index) => index !== localIndex);
        },
        addProductNumber(productNumber) {
            if (this.productNumbers.some(x => x.productNumber === productNumber)) {
                return;
            }

            this.productNumbers.push({
                productNumber,
            });
        },
    },
};
